import React from 'react';
import * as Sentry from '@sentry/react';

/**
 * Fallback UI when a React render error is caught.
 * Also reports to Sentry via Sentry.ErrorBoundary.
 */
function Fallback({ error, resetError }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'system-ui, sans-serif',
        background: '#f8fafc',
        color: '#0f172a',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
          Something went wrong
        </h1>
        <p style={{ fontSize: 14, color: '#64748b', marginBottom: 20 }}>
          An unexpected error occurred. Please try again.
        </p>
        {process.env.NODE_ENV === 'development' && error?.message ? (
          <pre
            style={{
              textAlign: 'left',
              fontSize: 12,
              background: '#fee2e2',
              color: '#991b1b',
              padding: 12,
              borderRadius: 8,
              overflow: 'auto',
              marginBottom: 16,
            }}
          >
            {error.message}
          </pre>
        ) : null}
        <button
          type="button"
          onClick={resetError}
          style={{
            background: '#0f172a',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '10px 18px',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export default function AppErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={Fallback} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
